const NUMBER_OF_OTP_INPUT = 6;
const DEFAULT_COUNT_DOWN_TIME = 2 * 60 * 1000;
const TITLE_TEXT = 'Xác thực OTP';
const RE_SEND_TEXT = 'Gửi lại mã OTP';
const EXPIRED_OTP = 'Mã xác thực OTP hết hiệu lực. Vui lòng chọn Gửi lại OTP để tiếp tục!';
export { NUMBER_OF_OTP_INPUT, DEFAULT_COUNT_DOWN_TIME, TITLE_TEXT, RE_SEND_TEXT, EXPIRED_OTP, };
